/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pwa_Update_AvailableInputs */

const vi_pwa_update_available = /** @type {(inputs: Pwa_Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Có bản cập nhật mới. Tải lại để dùng bản mới nhất.`)
};

/**

* @param {Pwa_Update_AvailableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pwa_update_available = /** @type {((inputs?: Pwa_Update_AvailableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwa_Update_AvailableInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pwa_update_available(inputs)
});